import React from "react";
import { useParams } from "react-router-dom";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/PublicLayout";
import { Breadcrumbs } from "@/components/Marketing";
import { LEGAL_PAGES } from "@/data/legal";
import NotFound from "@/pages/NotFound";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];
  if (!page) return <NotFound />;

  return (
    <PublicLayout>
      <Seo title={page.title} description={page.seoDescription} path={`/${slug}`} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: page.title }]} />
      <article className="container-x max-w-3xl py-8">
        <h1 className="font-heading text-4xl font-black uppercase tracking-tighter">{page.title}</h1>
        <p className="mt-3 rounded-lg bg-amber-50 p-3 text-sm text-amber-800">{page.updated}</p>
        <div className="mt-8 space-y-8">
          {page.sections.map(([h, p], i) => (
            <section key={i}>
              <h2 className="font-heading text-xl font-bold">{h}</h2>
              <p className="mt-2 leading-relaxed text-zinc-600">{p}</p>
            </section>
          ))}
        </div>
      </article>
    </PublicLayout>
  );
}
